const baseUrl =
	process.env.NODE_ENV === "production" ? "/" : "https://sbvn.ascentis.com.sg/"
const languages = [
	{ name: "English", code: "en" },
	{ name: "Vietnamese", code: "vi" },
]
const currency = "VND"
const recaptchaKey =
	process.env.REACT_APP_RECAPCHA_SITE_KEY === "{{REACT_APP_RECAPCHA_SITE_KEY}}"
		? "6LcgmVoUAAAAAJHacqlBEnC8P4bkVO1GAyVeBJCJ"
		: process.env.REACT_APP_RECAPCHA_SITE_KEY ||
		  "6LcgmVoUAAAAAJHacqlBEnC8P4bkVO1GAyVeBJCJ" // SB site key
const appStoreUrl = "https://itunes.apple.com/vn/app/id1410451879?mt=8"
const ggStoreUrl = "https://play.google.com/store/apps/details?id=com.starbucks.vn"
const termOfUseUrlVn =
	"https://www.starbucks.vn/ve-chung-toi/cong-ty/chinh-sach-truc-tuyen/starbucks-rewards-terms-and-conditions/"
const termOfUseUrlEn =
	"https://en.starbucks.vn/about-us/company-information/online-policies/starbucks-rewards-terms-and-conditions/"

const maxTransferAmount = 5000000
const timeoutConfigs = {
	warnTimeoutMins: 12,
	logoutTimeoutMins: 15,
	refreshIntervalMins: 10,
}
const captchaThreshold = 0
const noOfStarsForFreeDrink = 25
const reloadMinAmt = 50000
const reloadMaxAmt = 5000000
const egiftMinAmt = 100000
const egiftMaxAmt = 5000000

const firebaseWebApiKey = process.env.REACT_APP_FIREBASE_WEB_API_KEY
const androidPackageName = process.env.REACT_APP_ANDROID_PACKAGE_NAME
const iosBundleId = process.env.REACT_APP_IOS_BUNDLE_ID
const iosAppStoreId = process.env.REACT_APP_IOS_APP_STORE_ID
const apiWrapper = process.env.REACT_APP_WRAPPER_API_ENDPOINT
const paymentApiEndpoint = `${process.env.REACT_APP_WRAPPER_API_ENDPOINT}/ms-payment/api`
const antiFraudSetting = {
	basicAuth: "",
	blackBox: "EREDAV",
	platform: "Web",
	appVersion: "1.0",
	transactionMarket: "VN",
	userMarket: "VN",
	countryCode: "855",
	transactions: {
		createAccount: {
			typeCode: "CreateAccount",
		},
		accountCreated: {
			typeCode: "AccountCreated",
		},
		signIn: {
			typeCode: "SignIn",
		},
		signInFailure: {
			typeCode: "SignInFailure",
		},
		addCard: {
			typeCode: "AddCard",
		},
		removeCard: {
			typeCode: "RemoveCard",
		},
		transferBalance: {
			typeCode: "TransferBalance",
		},
		reload: {
			typeCode: "Reload",
		},
		egift: {
			typeCode: "Egift",
		},
	},
	DataCollectorUrl: "https://test.accdab.net/cdn/cs/HTaDglrHo2DGgUSh-84xHRxM5H4.js", // https://prod.accdab.net/cdn/cs/YTEcPK4ahoqD1E0_xlHtU5NwP-Q.js
}
export {
	baseUrl,
	languages,
	currency,
	recaptchaKey,
	maxTransferAmount,
	appStoreUrl,
	ggStoreUrl,
	timeoutConfigs,
	captchaThreshold,
	noOfStarsForFreeDrink,
	reloadMinAmt,
	reloadMaxAmt,
	egiftMinAmt,
	egiftMaxAmt,
	firebaseWebApiKey,
	androidPackageName,
	iosBundleId,
	iosAppStoreId,
	paymentApiEndpoint,
	apiWrapper,
	termOfUseUrlVn,
	termOfUseUrlEn,
	antiFraudSetting,
}
